<template>
	<section class="gaokao-content centerWidth" style="width: 1400px;">
		<div class="tb_padding">
			<article>
				<ul class="gkTest-step">
					<li>
						<div class="step-con step-on flex zhong center">
							<div>
								<img src="../../../image/zn_aa.png" />
								<span>基本信息</span>
							</div>
						</div>
					</li>
					<li>
						<div class="step-con flex zhong center"><img src="../../../image/Eva-arr-aa.png" /></div>
					</li>
					<li>
						<div class="step-con step-on flex zhong center">
							<div>
								<img src="../../../image/zn_bb.png" />
								<span>意向选择</span>
							</div>
						</div>
					</li>
					<li>
						<div class="step-con flex zhong center"><img src="../../../image/Eva-arr-a.png" /></div>
					</li>
					<li>
						<div class="step-con step-on flex zhong center">
							<div>
								<img src="../../../image/zn_cc.png" />
								<span>精确选择</span>
							</div>
						</div>
					</li>
					<li>
						<div class="step-con flex zhong center"><img src="../../../image/Eva-arr-a.png" /></div>
					</li>
					<li>
						<div class="step-con step-on flex zhong center">
							<div>
								<img src="../../../image/zn_dd.png" />
								<span>生成志愿表</span>
							</div>
						</div>
					</li>
				</ul>
			</article>
			<!-- 专业选择 -->
			<div class="div_padding">
				<ul>
					<!-- <li class=" flex zhong">
						<div class="tba_dl flex zhong">
							<label>院校名称：</label>
							<div class="tba_input">
								<el-input v-model="model.searchCollegesName" placeholder="请输入院校名称"></el-input>
							</div>
						</div>
						<div class="tba_dl flex zhong">
							<label>专业名称：</label>
							<div class="tba_input">
								<el-input v-model="model.searchMajorName" placeholder="请输入专业名称"></el-input>
							</div>
						</div>
						<div class="tba_dl flex zhong">
							<label>院校地区：</label>
							<div class="tba_input">
								<el-select v-model="searchCitysCode" @change="handleSearchCitysCodeChange" multiple
									collapse-tags placeholder="请选择院校地区">
									<el-option v-for="item in threeOptions" :key="item.Id" :label="item.Name"
										:value="item.Name"></el-option>
								</el-select>
							</div>
						</div>
						<div class="tba_dl flex zhong"><button class="zhun_btn" style="margin-left: 20px;"
								@click="getList">搜索</button></div>
					</li> -->
					<li class=" flex zhong float">
						<!-- <div class="flex">
							<button class="zhun_btn" :class="model.isMajorNames ? 'on' : ''"
								@click="handleMajorName">我的意向专业</button>
							<button class="zhun_btn" :class="model.isCollegesNames ? 'on' : ''"
								@click="handleCollegesName">我的意向院校</button>
							<button class="zhun_btn" :class="model.isCollegesAreas ? 'on' : ''"
								@click="handleCollegesArea">我的意向省市</button>
						</div> -->
						<div class="flex">
							<button class="zhun_btn" @click="goPrev">上一步</button>
							<button class="zhun_btn" @click="resetCondition">刷新页面</button>
							<button class="zhun_btn" @click="downloadExcel">
								方案下载
								<span>(EXCEL)</span>
							</button>
							<button class="zhun_btn" @click="downloadPdf">
								方案下载
								<span>(PDF)</span>
							</button>
						</div>
					</li>
				</ul>
			</div>
			<div class="state-type flex zhong">
				<p :class="{ 'on-type': isTab === 0 ? 1 : 1 }" @click="selectCwb(1)"><span></span>冲({{chong}})</p>
				<p @click="selectCwb(2)" :class="{ 'on-type': isTab === 0 ? 2 : 2 }"><span></span>稳({{wen}})</p>
				<p @click="selectCwb(3)" :class="{ 'on-type': isTab === 0 ? 3 : 3 }"><span></span>保({{bao}})</p>
                  <div style="    font-size: 14px;  color: #fa4237; padding-left: 20px;">注*：可拖动进行排序修改</div> 
			</div>
		</div>
      
		<div class="tbc_tabel">
			<article>
				<el-table ref="dataTable" :data="list" highlight-current-row border row-key="id" style="width: 100%"
					:row-class-name="tableRowClassName" @sort-change="customSort" v-loading="loading">
					<!-- <el-table-column
                            label="序号"
                            width="60"
                            prop="Sort"
                        ></el-table-column> -->
					<el-table-column label="序号" width="50" prop="index">
						<template slot-scope="scope">
							{{ getIndex(scope.row.Id) }}
						</template>
					</el-table-column>
					<el-table-column prop="Rate" sortable="custom" :label="columnName.RateStr || '录取概率'" width="110">
						<template slot-scope="scope">
							<div>
								{{scope.row.Remarks?scope.row.Remarks:scope.row.Rate}}
							</div>
						</template>
					</el-table-column>
					<el-table-column :label="columnName.PositionStr || '志愿位置'" width="50">
						<template slot-scope="scope">
							<div>
								<p style="color: #fa4237;" v-if="scope.row.Position === '冲'">冲</p>
								<p style="color: #f3af3b;" v-else-if="scope.row.Position === '稳'">稳</p>
								<p style="color: #42ab3f;" v-else-if="scope.row.Position === '保'">保</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column :label="columnName.CollegesNameStr || '院校名称'" width="200">
						<template slot-scope="scope">
							<div class="name_div ">
								<div class="flex zhong">
									<!-- 22.2.15  @click="xueTo(scope.row.CollegesName)" -->
									<p style="width: calc(100% - 25px);cursor: pointer;"
										:style="scope.row.IsCollegesNames?'color: #fa4237;':''"
										:class="{ 'red-text': scope.row.IsCollegesNames }"
										@click="collegePop(scope.row.CollegeProfile)">
										{{ scope.row.CollegesName | shortName }}
									</p>
									<el-tooltip class="item" effect="dark" :content="scope.row.CollegesName"
										placement="bottom">
										<img src="../../../image/shkl.png"
											style="width: 23px;height: 16px;margin-left: 0.5em;cursor: pointer;" />
									</el-tooltip>
								</div>
								<p>院校代码：{{ scope.row.CollegesCode }}</p>
								<p>院校类别：{{ scope.row.CollegesType }}</p>
								<p>院校类型：{{ scope.row.CollegesMold }}</p>
								<p>特色：{{ scope.row.Characte }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column :label="columnName.CollegesAreaStr || '院校地区'" width="60">
						<template slot-scope="scope">
							<div>
								<p :class="{ 'red-text': scope.row.IsCollegesAreas }">{{ scope.row.CollegesArea }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="MajorCode" :label="columnName.MajorCodeStr || '专业代码'" width="60">
					</el-table-column>
					<el-table-column :label="columnName.MajorNameStr || '专业名称'" width="180">
						<template slot-scope="scope" v-if="scope.row.Type === 2">
							<div class="name_div ">
								<div class="flex zhong">
									<!-- 22.2.15  @click="showMajorDetail(scope)" -->
									<p style="width: calc(100% - 25px);cursor: pointer;"
										:style="scope.row.IsMajorNames?'color: #fa4237;':''"
										@click="majorPop(scope.row.MajorProfile)"
										:class="{ 'red-text': scope.row.IsMajorNames }">
										{{ scope.row.MajorName | shortName }}
									</p>
									<el-tooltip class="item" effect="dark" :content="scope.row.MajorName"
										placement="bottom">
										<img src="../../../image/shkl.png"
											style="width: 23px;height: 16px;margin-left: 0.5em;cursor: pointer;" />
									</el-tooltip>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column :label="columnName.EducationalStr || '学制/学费'" width="102">
						<template slot-scope="scope">
							{{ `${scope.row.Educational || '暂无'}/${scope.row.Tuition || '暂无'}` }}
						</template>
					</el-table-column>
					<el-table-column :label="columnName.NewPlanStr || '计划'">
						<el-table-column prop="NewPlan" :label="columnName.Year || ''" width="52"></el-table-column>
					</el-table-column>
					<el-table-column :label="columnName.YearsDateStr || '历年数据'">
						<el-table-column prop="yeara" :label="columnName.Year1 || `${currentYear - 1}`" width="100"
							sortable="custom" sort-by="LowestScore">
							<template slot-scope="scope" >
								<div class="name_div " v-if="scope.row.YearsDate1&&scope.row.YearsDate1.LowestScore&&scope.row.Remarks!='新增'">
									<p>计划：{{ scope.row.YearsDate1.NewPlan }}</p>
									<!-- <p>平均分：{{ scope.row.YearsDate1.Average }}</p> -->
									<p>最低分：{{ scope.row.YearsDate1.LowestScore }}</p>
									<p>最低位次：{{ scope.row.YearsDate1.LowestOrder }}</p>
								</div>
								<div class="name_div " v-else>
									<p>未招生</p>
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="yearb" :label="columnName.Year2 || `${currentYear - 2}`" width="100"
							sortable="custom" sort-by="LowestScore">
							<template slot-scope="scope" >
								<div class="name_div " v-if="scope.row.YearsDate2&&scope.row.YearsDate2.LowestScore">
									<p>计划：{{ scope.row.YearsDate2.NewPlan }}</p>
									<!-- <p>平均分：{{ scope.row.YearsDate2.Average }}</p> -->
									<p>最低分：{{ scope.row.YearsDate2.LowestScore }}</p>
									<p>最低位次：{{ scope.row.YearsDate2.LowestOrder }}</p>
								</div>
								<div class="name_div " v-else>
									<p>未招生</p>
								</div>
							</template>
							
						</el-table-column>
						<el-table-column prop="yearc" :label="columnName.Year3 || `${currentYear - 3}`" width="100"
							sortable="custom" sort-by="LowestScore">
							<template slot-scope="scope" >
								<div class="name_div " v-if="scope.row.YearsDate3&&scope.row.YearsDate3.LowestScore">
									<p>计划：{{ scope.row.YearsDate3.NewPlan }}</p>
									<!-- <p>平均分：{{ scope.row.YearsDate3.Average }}</p> -->
									<p>最低分：{{ scope.row.YearsDate3.LowestScore }}</p>
									<p>最低位次：{{ scope.row.YearsDate3.LowestOrder }}</p>
								</div>
								<div class="name_div " v-else>
									<p>未招生</p>
								</div>
							</template>
							
						</el-table-column>
					</el-table-column>
					<el-table-column prop="AdmissionBatch" :label="columnName.BatchStr || '批次'"
						width="60"></el-table-column>
					<el-table-column prop="RequirementsSubjects" :label="columnName.RequirementsSubjectsStr || '选考科目'"
						width="60"></el-table-column>
					<el-table-column prop="Average"  :label="columnName.MajorGroupStr || '专业组'" width="60">
						
					</el-table-column>
					<!-- <el-table-column :label="columnName.UserAttentionStr || '关注'" width="60">
						<template slot-scope="scope">
							<img :src="scope.row.UserAttention ? require('../../../image/gz_aa.png') : require('../../../image/gz_a.png')"
								class="scImg" style="zoom: 0.7;" @click="attentItem(scope)" />
						</template>
					</el-table-column> -->
					<el-table-column label="操作" width="55">
						<template slot-scope="scope">
							<div class="flex zhong center" style="flex-direction: column;padding-right: 5px;">
								<el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除
								</el-button>
								<el-button v-if="scope.row.Type === 1" size="mini"
									style="margin-top: 20px;margin-left: 0 !important;"
									@click="showCollegeMajor(scope.row.ContentId, scope.row.Id)">
									专业
								</el-button>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</article>
		</div>
		</div>
		<!-- 选择专业 22.2.14-->
		<aside class="popup flexCenter" v-if="isZhuanPop">
			<div class="ptzhuan_bai">
				<img src="../../../image/vol-del-t.png" @click="isZhuanPop = false" />
				<div class="ptzhuan_h6">选择专业</div>
				<div style="height: 400px;overflow: auto;" v-if="!ZyNoData">
					<div class="ptzhuan_list flex wrap">
						<p v-for="(item, index) in zhuanList" :key="index" @click="zhuanYeTo(item)">{{item.Name}}</p>
					</div>
				</div>
				<div class="ptend_gao" v-else>
					<div class=" ptend_div">
						<img src="../../../image/empty.png" />
						<p>暂无数据</p>
					</div>
				</div>
			</div>
		</aside>

		<aside class="popup flexCenter" v-if="isYXPop">
			<div class="ptzhuan_bai">
				<img src="../../../image/vol-del-t.png" @click="isYXPop = false" />
				<div class="ptzhuan_h6">选择院校</div>
				<div style="height: 400px;overflow: auto;" v-if="!YXNodata">
					<div class="ptzhuan_list flex wrap">
						<p v-for="(item, index) in YxList" :key="index" @click="yuanXiaoTo(item)">{{item.Name}}</p>
					</div>
				</div>
				<div class="ptend_gao" v-else>
					<div class=" ptend_div">
						<img src="../../../image/empty.png" />
						<p>暂无数据</p>
					</div>
				</div>
			</div>
		</aside>
		<!-- 专业 -->
		<aside class="popup flex zhong center" v-if="isZyPop">
			<div class="aside_pop">
				<div class="aside_height">
					<ul>
						<li class="pointer" v-for="(item, index) in majorDetail" :key="index"
							@click="goMajorInfo(item.Id)">{{ item.Name }}</li>
					</ul>
				</div>
				<div class="aside_btn flex zhong center"><button class="zhun_btn"
						@click="(isZyPop = false), (majorDetail = [])">关闭</button></div>
			</div>
		</aside>
		<el-dialog v-if="collogeMajorVisible" width="1263px" :title="currentCollegeMajor.name" :visible.sync="collogeMajorVisible"
			:close-on-click-modal="false" top="50px">
			<college-major :tableType="1" :selectId="selectId" :list="currentCollegeMajor.list" :columnName="columnName"
				@showMajorDetail="showMajorDetail"></college-major>
			<span slot="footer" class="dialog-footer">
				<el-button @click="closeCollegeMajor(false)">关闭 </el-button>
			</span>
		</el-dialog>
		<!-- 5.30 -->
		<div class="ptpopupTc flexCenter" v-show="isJiaIng">
			<div class="ptpotxt">
				<div class="ptadiva" id="myChartYuan"></div>
				<p>请稍等,正在为您生成报告...</p>
			</div>
		</div>
	</section>
</template>

<script>
	import Sortable from 'sortablejs';
	import CollegeMajor from './CollegeMajor';

	const queryModel = {
		userId: 0,
		selectId: 0,
		isCollegesAreas: false,
		isMajorNames: false,
		isCollegesNames: false,
		preferredSubject: '',
		requirementsSubjects: '',
		searchMajorName: '',
		searchCollegesName: '',
		searchCitysCode: '',
		// 1=Sort 2=录取概率 3=历年数据1 4=历年数据2 5=历年数据3
		SortType: 1,
		totleScore: 0
	};

	const now = new Date();

	// const IS_PROD = ['production', 'prod'].includes(process.env.NODE_ENV);

	export default {
		components: {
			CollegeMajor
		},
		data() {
			return {
				ZyNoData: false,
				YXNodata: false,
				isTab: 0,
				// 当前弹窗显示专业
				currentCollegeMajor: {
					id: 0,
					name: '',
					list: []
				},
				// 是否显示院校专业弹窗
				collogeMajorVisible: false,
				model: {
					...queryModel,
					userId: this.$store.state.user.userId,
					selectId: this.$parent.selectId,
					totleScore: this.$parent.totalScore
				},
				selectId:0,
				currentYear: now.getFullYear(),
				// 专业院校地区
				searchCitysCode: [],
				columnName: {},
				isPop: false,
				isZyPop: false,
				threeOptions: [],
				list: [],
				originList: [],
				majorDetail: [],
				loading: false,
				isZhuanPop: false,
				chong: 0,
				wen: 0,
				bao: 0,
				isYXPop: false,
				YxList: [],
				zhuanList: [],
				isJiaIng: false
			};
		},
		created() {
			this.getConditions();
			this.getColumnName();
			this.getList();
		},
		beforeDestroy() {
			if (this.ratioTime) {
				clearTimeout(this.ratioTime);
				this.ratioTime = null;
			}
		},
		mounted() {
			this.selectId = this.$parent.selectId;
			this.drawLineB(0);
		},
		methods: {
			drawLineB(nub) {
				var that = this;
				console.log('nub', nub);
				const myChart = this.$echarts.init(document.getElementById('myChartYuan'));
				myChart.setOption({
					color: ['#feb9a7', '#3171ff00'],
					tooltip: {
						trigger: 'item',
						show: false
					},
					graphic: {
						type: 'text',
						left: 'center',
						top: 'center',
						style: {
							text: nub + '%',
							textAlign: 'center',
							fill: '#7ac8fd',
							fontSize: 24
						}
					},
					legend: {
						top: '0%',
						left: 'center'
					},
					series: [{
						type: 'pie',
						radius: ['55%', '65%'],
						avoidLabelOverlap: false,
						hoverAnimation: false,
						label: {
							show: false,
							position: 'center'
						},
						emphasis: {
							label: {
								show: true,
								fontSize: '40',
								fontWeight: 'bold'
							}
						},
						labelLine: {
							show: true
						},
						data: [{
							value: nub,
							name: ''
						}, {
							value: (100 - nub),
							name: ''
						}]
					}]
				});
				if (nub > 0 && nub < 100) {
					that.ratioTime = setTimeout(() => {
						var dd = nub;
						if (dd === 99) {
							dd = 99;
						} else if (dd > 80) {
							dd = dd + 1;
						} else if (dd > 60) {
							dd = dd + 5;
						} else {
							dd = dd + 10;
						}
						that.drawLineB(dd);
					}, 1000);
				} else {
					if (that.ratioTime) {
						clearTimeout(that.ratioTime);
						that.ratioTime = null;
					}
				}
			},
			yuanXiaoTo(item) {
				// 院校名称
				window.open(`${window.location.origin}${window.location.pathname}#/schoolinfo?schoolname=${item.Name}`);
				// 专业  majorinfo
				// this.$router.push('/majorinfo')
				// this.$router.push({
				// 	path: './schoolinfo',
				// 	query: {
				// 		schoolname: item.schoolname
				// 	}
				// });
			},
			zhuanYeTo(item) {
				// 院校名称
				// window.open(
				// 	`${window.location.origin}${window.location.pathname}#/schoolinfo?schoolname=${item.SchoolName}`);
				// 专业  majorinfo
				// this.$router.push('/majorinfo')
				var routeUrl = this.$router.resolve({
					path: '/majorinfo',
					query: {
						Id: item.Id
					}
				});
				window.open(routeUrl.href, '_blank');
			},
			collegePop(row) {
				this.isYXPop = true;
				this.YxList = row;
				this.YXNodata = this.YxList.length === 0;
			},
			majorPop(row) {
				this.isZhuanPop = true;
				this.zhuanList = row;
				this.ZyNoData = this.zhuanList.length === 0;
			},
			closeCollegeMajor() {
				this.collogeMajorVisible = false;
			},
			// 显示院校中的专业
			showCollegeMajor(collegeId, id) {
				// console.log('点击',collegeId, id);
				// console.log('this.originList',this.originList);
				const college = this.originList.find(a => a.Id === id);
				if (!college) {
					// console.log('这里返回了college',college);
					return;
				}
				this.currentCollegeMajor.id = id;
				this.currentCollegeMajor.name = college.CollegesName;
				// if (college.majorList) {
				// 	this.currentCollegeMajor.list = college.majorList;
				// 	if (college.majorList.length > 0) {
				// 		this.collogeMajorVisible = true;
				// 	} else {
				// 		this.$util.showMsg(true, '未选择该院校专业', 'warning');
				// 	}
				// 	return;
				// }
				const dto = {
					...queryModel,
					userId: this.$store.state.user.userId,
					selectId: this.$parent.selectId,
					type: 1,
					parentCollegeId: collegeId
				};
				this.$api.getVolunteerList(dto).then(res => {
					this.currentCollegeMajor.list  = [];
					college.majorList = res.data.list;
					this.chong = res.data.chong;
					this.wen = res.data.wen;
					this.bao = res.data.bao;
					this.currentCollegeMajor.list = college.majorList;
					console.log('列表',this.currentCollegeMajor.list);
					if (college.majorList.length > 0) {
						this.collogeMajorVisible = true;
					} else {
						this.$util.showMsg(true, '未选择该院校专业', 'warning');
					}
				});
			},
			// 排序
			customSort({
				order,
				prop
			}) {
				if (order) {
					switch (prop) {
						case 'Rate':
							this.model.SortType = order === 'descending' ? 21 : 2;
							break;
						case 'yeara':
							this.model.SortType = order === 'descending' ? 31 : 3;
							break;
						case 'yearb':
							this.model.SortType = order === 'descending' ? 41 : 4;
							break;
						case 'yearc':
							this.model.SortType = order === 'descending' ? 51 : 5;
							break;
					}
				} else {
					this.model.SortType = 1;
				}
				this.getList();
			},
			// 获取index
			getIndex(id) {
				return this.originList.findIndex(a => a.Id === id) + 1;
			},
			// 跳转招生章程
			goSolution(url) {
				window.open(url);
			},
			// 删除志愿
			handleDelete(index, row) {
				this.$api
					.accurateDeleteVolunteer({
						Id: row.Id
					})
					.then(res => {
						this.$util.showOk('删除成功');
						this.getList();
					});
			},
			// 拖动排序
			setSort() {
				const el = this.$refs.dataTable.$el.querySelectorAll('.el-table__body-wrapper > table > tbody')[0];
				this.sortable = Sortable.create(el, {
					ghostClass: 'sortable-ghost', // Class name for the drop placeholder,
					setData: function(dataTransfer) {
						// to avoid Firefox bug
						// Detail see : https://github.com/RubaXa/Sortable/issues/1012
						dataTransfer.setData('Text', '');
					},
					forceFallback: true,
					onEnd: evt => {
						if (evt.oldIndex !== evt.newIndex) {
							const targetRow = this.originList.splice(evt.oldIndex, 1)[0];
							this.originList.splice(evt.newIndex, 0, targetRow);
							this.sortList();
						}
					}
				});
			},
			// 设置行样式类名
			tableRowClassName({
				row
			}) {
				if (row.Type === 1) {
					return 'pink';
				}
				return 'blue';
			},
			// 排序后调用接口
			sortList() {
				this.$api.volunteerSetSort({
					Ids: this.originList.map(a => a.Id).join(','),
					SelectId: this.$parent.selectId
				}).then(res => {
					this.$alert('排序修改成功', '', {
						confirmButtonText: '确定'
					});
				});
			},
			// 获取筛选条件的数据
			async getConditions() {
				const res = await this.$api.getAccurateCity();
				this.threeOptions = res.data;
			},
			// 获取志愿表
			async getList() {
				this.loading = true;
				try {
					const res = await this.$api.getVolunteerList(this.model);
					console.log(res);
					this.loading = false;
					this.chong = res.data.chong;
					this.wen = res.data.wen;
					this.bao = res.data.bao;
					this.list = this.$util.clone(res.data.list);
					console.log('this.list', this.list);
					this.list.map(a => {
						a.isPop = a.Remarks.includes('新增');
					});
					this.originList = this.$util.clone(res.data.list);
					!this.sortable &&
						this.$nextTick(() => {
							this.setSort();
						});
				} catch (error) {
					this.loading = false;
					console.error(error);
				}
			},
			// 获取表头名
			async getColumnName() {
				const res = await this.$api.getColumnName();
				this.columnName = res.data;
			},
			// 选择院校地区
			handleSearchCitysCodeChange(e) {
				this.model.searchCitysCode = e.join(',');
			},
			// 点击我的意向专业
			handleMajorName() {
				this.model.isMajorNames = !this.model.isMajorNames;
				this.list = [];
				this.getList();
			},
			// 点击我的意向院校
			handleCollegesName() {
				this.model.isCollegesNames = !this.model.isCollegesNames;
				this.list = [];
				this.getList();
			},
			// 点击我的意向省市
			handleCollegesArea() {
				this.model.isCollegesAreas = !this.model.isCollegesAreas;
				this.list = [];
				this.getList();
			},
			// 重置条件（点击刷新页面）
			resetCondition() {
				this.model = {
					...queryModel,
					userId: this.$store.state.user.userId,
					selectId: this.$parent.selectId
				};
				this.list = [];
				this.originList = [];
				this.searchCitysCode = [];
				this.$refs.dataTable.clearSort();
				this.getList();
			},
			// 关注
			attentItem(scope) {
				scope.row.UserAttention = !scope.row.UserAttention;
				this.$api
					.accurateAttentionAdd({
						userId: this.$store.state.user.userId,
						contentId: scope.row.ContentId,
						type: scope.row.Type
					})
					.then(() => {
						this.$util.showOk(scope.row.UserAttention ? '关注成功' : '取消关注成功');
					})
					.catch(() => {
						scope.row.UserAttention = !scope.row.UserAttention;
					});
			},
			// 显示专业介绍
			showMajorDetail(scope) {
				this.majorDetail = scope.row.MajorProfile;
				this.isZyPop = true;
			},
			// 下载excel
			downloadExcel() {
				this.isJiaIng = true;
				this.drawLineB(10);
				this.$api
					.getAccurateExcelUrl({
						vid: this.$parent.firstId
					})
					.then(res => {
						this.drawLineB(100);
						setTimeout(() => {
							this.isJiaIng = false;
							setTimeout(() => {
								this.drawLineB(0);
							}, 300);
							if (res.url) {
								// window.open(
								// 	`${IS_PROD ? window.location.origin + '/' : process.env.VUE_APP_BASE_API}/${res.url}`
								// );
								window.open(res.url);
							} else {
								this.$util.showError('下载无效');
							}
						}, 500);
					})
					.catch(() => {
						this.isJiaIng = false;
						this.drawLineB(0);
					});
			},
			// 下载pdf
			downloadPdf() {
				this.isJiaIng = true;
				this.drawLineB(10);
				this.$api
					.getAccuratePdfUrl({
						id: this.$parent.firstId
					})
					.then(res => {
						this.drawLineB(100);
						setTimeout(() => {
							this.isJiaIng = false;
							setTimeout(() => {
								this.drawLineB(0);
							}, 300);
							// loading.close();
							if (res.data) {
								window.open(res.data);
							} else {
								this.$util.showError('下载链接无效');
							}
						}, 500);
					})
					.catch(() => {
						this.isJiaIng = false;
						this.drawLineB(0);
					});
			},
			// 跳转学校
			xueTo(name) {
				window.open(`${window.location.origin}${window.location.pathname}#/schoolinfo?schoolname=${name}`);
				// this.$router.push({
				//     path: '/schoolinfo',
				//     query: {
				//         schoolname: name
				//     }
				// });
			},
			// 上一步
			goPrev() {
				this.$parent.goNext(2);
			},
			// 前往专业详情页
			goMajorInfo(id) {
				window.open(`${window.location.origin}${window.location.pathname}#/majorinfo?Id=${id}`);
			}
		}
	};
</script>
<style scoped>
	/* 2.23 */

	/* state-type */
	.state-type {
		width: 100%;
		height: auto;
	}

	.state-type p {
		font-size: 15px;
		color: #fa4237;
		margin-left: 30px;
		text-align: center;
		position: relative;
		cursor: pointer;
		display: flex;
		align-items: center;
	}

	.state-type p:nth-child(2) {
		color: #f3af3b;
	}

	.state-type p:nth-child(3) {
		color: #42ab3f;
	}

	.state-type p span {
		width: 7px;
		height: 7px;
		border-radius: 50px;
		background-color: #fa4237;
		display: inline-block;
		margin-right: 10px;
	}

	.state-type p:nth-child(2) span {
		background-color: #f3af3b;
	}

	.state-type p:nth-child(3) span {
		background-color: #42ab3f;
	}

	/* .state-type p::after {
		position: absolute;
		content: '';
		width: 40px;
		height: 0;
		border-bottom: 3px solid transparent;
		border-radius: 50px;
		bottom: 0;
		left: 50%;
		margin-left: -20px;
	}

	.state-type .on-type {
		color: #0079fe;
		font-weight: bold;
	}

	.state-type .on-type::after {
		border-bottom: 3px solid #0079fe;
	}
 */
	.zypt {
		display: inline-block;
		padding-bottom: 10px;
		border-bottom: solid 1px #94918f;
		cursor: pointer;
	}

	/* 01 */

	.red-text {
		color: red !important;
	}

	.sortable-ghost {
		opacity: 0.8;
		color: #fff !important;
		background: #42b983 !important;
	}

	.aside_height li {
		border-bottom: solid 1px #eeeeee;
		padding: 14px 0;
		text-indent: 1em;
		font-size: 14px;
		color: #666666;
	}

	.aside_height {
		height: 320px;
		overflow-y: auto;
		border-radius: 6px;
		border: solid 1px #eeeeee;
	}

	.tbc_tabel.active /deep/.el-table--border td {
		background-color: #fff4ee;
	}

	/deep/.el-table thead.is-group th {
		background-color: #bddcf6;
	}

	.name_div>p {
		font-size: 12px !important;
		color: #999 !important;
		text-align: left !important;
	}

	.name_div>p span {
		color: #666 !important;
	}

	.table img.scImg {
		display: block;
		width: 20px;
		height: 20px;
		margin: 0 auto;
		cursor: pointer;
	}

	.table p {
		text-align: center;
		font-size: 14px;
		font-weight: normal;
		color: #333;
	}

	/deep/.el-table td,
	/deep/.el-table th {
		padding: 5px 0 !important;
	}

	/deep/.cell {
		text-align: center;
		font-size: 14px;
		font-weight: normal;
		color: #333;
	}

	.table p span {
		font-size: 14px;
		color: #333;
		padding-bottom: 8px;
		border-bottom: solid 1px #333;
		line-height: initial;
		margin: 0 10px;
		cursor: pointer;
	}

	.table li p {
		font-size: 14px;
		width: calc(100% / 6);
		line-height: 60px;
		text-align: center;
		color: #666666;
	}

	.table li:last-child {
		border-bottom: none;
	}

	.table li p:last-child {
		border-right: none;
	}

	.table li {
		border-bottom: solid 1px #e6e6e6;
	}

	.table ul {
		overflow: hidden;
	}

	.table hgroup p {
		font-size: 14px;
		background-color: #eaeaea;
		width: calc(100% / 6);
		line-height: 60px;
		text-align: center;
	}

	.table {
		height: 500px;
		overflow: auto;
		border: solid 1px #e6e6e6;
		box-sizing: border-box;
	}

	/* 01 */

	.tbc_tabel {
		width: 100%;
		margin-top: 20px;
		/*    height: 600px;
    overflow: auto; */
	}

	/* tbc_tabel */

	.aside_btn .zhun_btn {
		background-color: #333;
		border: solid 1px #333;
	}

	.aside_btn .zhun_btn:first-child {
		background-color: #fff;
		color: #333;
		border: solid 1px #333;
	}

	.aside_btn {
		margin-top: 40px;
	}

	.aside_box {
		width: 70%;
		margin: 0 10px;
	}

	.aside_div {
		width: 90%;
		margin: 0 auto;
	}

	.aside_pop {
		width: 520px;
		border-radius: 10px;
		background-color: #fff;
		padding: 50px 20px 20px 20px;
	}

	/* aside_pop */

	/deep/.el-slider__button-wrapper:nth-child(2)::before {
		content: '-';
		font-size: 18px;
		font-weight: bold;
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
		z-index: 1;
		text-align: center;
		line-height: 35px;
	}

	/deep/.el-slider__button-wrapper:nth-child(3)::before {
		content: '+';
		font-size: 18px;
		font-weight: bold;
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
		z-index: 1;
		text-align: center;
		line-height: 35px;
	}

	/deep/.el-slider__button {
		width: 24px;
		height: 24px;
		background-color: #fff;
		border: solid 1px #dddddd;
		border-radius: 4px;
	}

	/deep/.el-slider__bar {
		background-color: #f3af3b;
	}

	/deep/.el-slider__runway {
		background-color: #fce4d6;
	}

	/deep/.el-slider__stop {
		background-color: transparent;
	}

	.block {
		width: 360px;
		margin: 0 20px;
	}

	.aside_div /deep/input {
		padding: 0 !important;
		text-align: center;
	}

	.tba_dl p {
		font-size: 14px;
		color: #333;
		margin: 0 10px;
	}

	.tba_dl label {
		font-size: 14px;
		color: #333;
		width: 80px;
		text-align: right;
		margin-right: 10px;
	}

	.tba_dl {
		min-width: 300px;
	}

	.div_padding li:nth-child(n + 2) {
		/* margin-top: 15px; */
		margin-top: 10px;
	}

	.zhun_btn.on {
		background-color: #005371 !important;
	}

	.zhun_btn {
		width: 120px;
		height: 40px;
		background-color: #666;
		border-radius: 4px;
		font-size: 14px;
		color: #fff;
		line-height: 40px;
		margin-right: 20px;
		display: block;
		cursor: pointer;
	}

	.zhun_btn:last-child {
		margin-right: 0;
	}

	/* zhun_btn */

	.div_padding {
		padding: 20px;
		width: 100%;
		border: solid 1px #dddddd;
		margin: 20px 0;
	}

	/* div_padding */

	.three_div p.on {
		background-color: #333;
		color: #fff;
	}

	.three_div p {
		width: 180px;
		height: 40px;
		border-top-left-radius: 4px;
		border-top-right-radius: 4px;
		border: solid 1px #dddddd;
		border-bottom: none;
		font-size: 16px;
		color: #333;
		line-height: 40px;
		text-align: center;
		cursor: pointer;
	}

	.three_div {
		margin: 20px 0;
		border-bottom: solid 2px #333;
	}

	/* three_div */
	.tb_padding {
		padding: 20px 20px 1px 20px;
	}

	.gkTest-step {
		margin-top: 0;
	}

	.gaokao-content {
		background-color: #fff;
		margin-bottom: 40px;
	}

	/deep/.el-table .pink {
		background: #fff4ee;
	}

	/deep/.el-table .blue {
		background-color: #ddebf7;
	}
</style>
